import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error("Application error", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="state-page" id="main-content" tabIndex={-1}>
          <p className="eyebrow">Something went wrong</p>
          <h1>We hit an unexpected turn.</h1>
          <p>Refresh the page or return to the ticket catalogue.</p>
          <a className="button button-primary" href="/tickets">View tickets</a>
        </main>
      );
    }
    return this.props.children;
  }
}
